import React from 'react';

import LTICourseDashboard from 'pages/CourseDashboard/LTI';
import PasswordCourseDashboard from 'pages/CourseDashboard/Password';
import PageProvider from 'pages/CourseDashboard/PageProvider';

const CourseDashboard = (props) => {
    return (
        <PageProvider {...props}>
            {process.env.REACT_APP_AUTH === 'LTI' ? <LTICourseDashboard /> : <PasswordCourseDashboard />}
        </PageProvider>
    );
};

export default CourseDashboard;
